import { NetworkService } from './network-service';

const API_BASE_URL = process.env.REACT_APP_API_EXECUTION_ADDRESS;

export default class CoverService {
    static async createCoverAsync(projectId, body) {
        return await NetworkService.postAsync(`${API_BASE_URL}/projects/${projectId}/covers`, body);
    }

    static async listCoversAsync(projectId) {
        const response = await NetworkService.getAsync(`${API_BASE_URL}/projects/${projectId}/covers`);
        return response.items || response || [];
    }
}
